module.exports = __webpack_public_path__ + "images/program/computer.b36ddc4c.svg";